import { render, staticRenderFns } from "./VxWebLink.vue?vue&type=template&id=69d37d41"
import script from "./VxWebLink.vue?vue&type=script&lang=js"
export * from "./VxWebLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports